import { CardContent, CardHeader } from "@material-ui/core";
import { DateField, FormInput, TextField } from "react-admin";
import React, { Fragment } from "react";

import { compose } from "recompose";
import withCardStyles from "../components/list/withCardStyles";

const Card = ({ classes, ...props }) => (
  <Fragment>
    <CardHeader
      className={classes.header}
      title={<TextField {...props} source="code" />}
    />
    <CardContent className={classes.content}>
      <FormInput
        {...props}
        source="device_type.name"
        input={<TextField addLabel />}
      />
      <FormInput {...props} source="created" input={<DateField addLabel />} />
    </CardContent>
  </Fragment>
);
export default compose(withCardStyles)(Card);
